import initFirebase from './firebase';
const initializeService = () => {
    //init services
    initFirebase();
}

export { initializeService }